
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class QuasarJetEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const curTime = time * config.parallaxSpeed;
        const scale = config.parallaxScale || 1.0;

        ctx.fillStyle = pc.color;

        const draw = () => {
             ctx.save();
             ctx.rotate(Math.PI / 4 + Math.sin(curTime * 0.1) * 0.2);
             
             // High energy jet
             const jetHeight = height * 4;
             const jetWidth = (50 + Math.sin(curTime * 10) * 20) * scale;
             
             const grad = ctx.createLinearGradient(0, -jetHeight/2, 0, jetHeight/2);
             grad.addColorStop(0, 'transparent');
             grad.addColorStop(0.5, pc.color);
             grad.addColorStop(1, 'transparent');
             
             ctx.globalAlpha *= 0.4 / (layerIndex + 1);
             ctx.fillStyle = grad;
             ctx.fillRect(-jetWidth/2, -jetHeight/2, jetWidth, jetHeight);
             
             // Particles in jet
             for (let i = 0; i < 20; i++) {
                 const py = ((curTime * 1000 + this.pseudoRandom(i) * 2000) % jetHeight) - jetHeight/2;
                 const px = (this.pseudoRandom(i + 1) - 0.5) * jetWidth;
                 ctx.beginPath();
                 ctx.arc(px, py, 3 * scale, 0, Math.PI * 2);
                 ctx.fill();
             }
             ctx.restore();
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
